module.exports = __webpack_public_path__ + "img/28.bfe7b1c4.jpg";